export default __webpack_public_path__ + "static/burredgrooves-3757b543b2b692135c7db542fc748e5c.png";